/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TherapyEndReasonEnum } from './therapyEndReasonEnum';
import { DiagnosisPermissions } from './diagnosisPermissions';
import { PatientDiagnosisSummary } from './patientDiagnosisSummary';
import { PatientListRowTherapist } from './patientListRowTherapist';
import { HealthInsuranceMinimal } from './healthInsuranceMinimal';
import { Practice } from './practice';
import { DigaEnum } from './digaEnum';
import { GenderEnum } from './genderEnum';
import { BillingTypeEnum } from './billingTypeEnum';
import { EditableMasterdataFieldsEnum } from './editableMasterdataFieldsEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientDetail { 
    readonly id: number;
    firstName?: string;
    lastName?: string;
    email: string;
    phone?: string;
    patientId: string;
    gender: GenderEnum;
    dob?: string | null;
    organizations: Array<string>;
    crmContactId?: string;
    crmDealId?: string;
    crmLeadId?: string;
    readonly street: string;
    readonly houseNumber: string;
    readonly addressAddition: string;
    readonly postalCode: string;
    readonly city: string;
    readonly insuranceNumber: string;
    readonly note: string;
    readonly stage: string;
    readonly confidentialityRelease: boolean;
    readonly kbReviewed: boolean;
    readonly therapyEnded: boolean;
    readonly therapyEndReasonOther: string;
    readonly hybridTherapy: boolean;
    readonly coTherapist: string;
    readonly invirtoDataSharingConsentOn: string | null;
    readonly dropoutReason: string;
    readonly sessionsPerWeek: string | null;
    readonly concern: string;
    readonly specifiedConcern: string;
    readonly bridgingSelfPay: boolean;
    therapist: PatientListRowTherapist | null;
    readonly practice: Practice | null;
    readonly healthInsurance: HealthInsuranceMinimal | null;
    readonly billingType: BillingTypeEnum | null;
    readonly digas: Array<DigaEnum>;
    readonly therapyEndReason: TherapyEndReasonEnum | null;
    readonly attendedSessionCount: number;
    readonly missingTreatmentPlan: boolean;
    readonly stageInactive: boolean;
    /**
     * ``None`` where no BV/DV consent applies: Invirto patients and practices without consent fields.
     */
    readonly bvDvConsentObtained: boolean | null;
    readonly diagnoses: Array<PatientDiagnosisSummary>;
    /**
     * ``None`` for users who may not see billing data.
     */
    readonly stripeEmail: string | null;
    readonly discount: string | null;
    /**
     * ``None`` for users who may not see billing data.
     */
    readonly withholdDocumentationOnTherapistChange: boolean | null;
    readonly editableMasterdataFields: Array<EditableMasterdataFieldsEnum>;
    readonly diagnosisPermissions: DiagnosisPermissions;
}
export namespace PatientDetail {
}

export const PatientDetail_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_firstName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const PatientDetail_lastName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const PatientDetail_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(254), Validators.email,];

export const PatientDetail_phone_Validators: ValidatorFn[] =
    [  Validators.maxLength(63),];

export const PatientDetail_patientId_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(7),];

export const PatientDetail_gender_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_dob_Validators: ValidatorFn[] =
    [ ];

export const PatientDetail_organizations_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_crmContactId_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const PatientDetail_crmDealId_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const PatientDetail_crmLeadId_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const PatientDetail_street_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_houseNumber_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_addressAddition_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_postalCode_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_city_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_insuranceNumber_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_note_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_stage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_confidentialityRelease_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_kbReviewed_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_therapyEnded_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_therapyEndReasonOther_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_hybridTherapy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_coTherapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_invirtoDataSharingConsentOn_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_dropoutReason_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_sessionsPerWeek_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.pattern('/^-?\\d{0,2}(?:\\.\\d{0,2})?$/'),];

export const PatientDetail_concern_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_specifiedConcern_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_bridgingSelfPay_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_practice_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_healthInsurance_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_billingType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_digas_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_therapyEndReason_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_attendedSessionCount_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_missingTreatmentPlan_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_stageInactive_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_bvDvConsentObtained_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_diagnoses_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_stripeEmail_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_discount_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.pattern('/^-?\\d{0,3}(?:\\.\\d{0,2})?$/'),];

export const PatientDetail_withholdDocumentationOnTherapistChange_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_editableMasterdataFields_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDetail_diagnosisPermissions_Validators: ValidatorFn[] =
    [  Validators.required, ];


